import { render, staticRenderFns } from "./InitiateReport.vue?vue&type=template&id=64ec4260&scoped=true&"
import script from "./InitiateReport.vue?vue&type=script&lang=js&"
export * from "./InitiateReport.vue?vue&type=script&lang=js&"
import style0 from "./InitiateReport.vue?vue&type=style&index=0&id=64ec4260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec4260",
  null
  
)

export default component.exports